var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"PassDiaryInputPageButton"}},[_c('button',{staticClass:"button",style:(_vm.buttonStyle),on:{"click":_vm.handleClick}},[(_vm.useBackIcon)?_c('span',[_vm._v(_vm._s(`く　`))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }